import React from "react";
import HilightBootstrapSwitch from "./HilightBootstrapSwitch/hilight-bootstrap-switch";
import {networkDeviceActions} from "../actions/network-device.actions";
import {modalActions} from "../actions/modal.actions";
import {connect} from "react-redux";
import {withNamespaces} from "react-i18next";

const SwitchDiagnosticMode = ({ t,  networkDeviceId, dataValue, showModal, hideModal, setDiagnosticMode }) => {

    const [diagnosticMode] = React.useState(dataValue);

    const openConfirmModal = (id, val) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: `<p>${t('change-diagnostic-mode-msg')}</p><p><b>${t('close-single-application-msg')}</b></p>`,
            confirmLabel: t('OK'),
            confirmIcon: 'fa-check-circle',
            classNameBtnConfirm: 'btn-info',
            dataId: id,
            confirmAction: (id) => {
                setDiagnosticMode(id, val);
                hideModal();
            },
            closeModal: closeModal,
        }, 'confirm')
    };

    const closeModal = () => {
        hideModal()
    };

    return (
        <HilightBootstrapSwitch
            checked={diagnosticMode}
            onlabel={"On"}
            offlabel={"Off"}
            onstyle={"danger"}
            onChange={(checked) => {
                openConfirmModal(networkDeviceId, checked)
            }}
        />
    )
};
const mapDispatchToProps = dispatch => ({
    setDiagnosticMode: (id, val) => dispatch(networkDeviceActions.setDiagnosticMode(id, val)),
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({ modalProps, modalType }))
    }
});
export default withNamespaces()(connect(null, mapDispatchToProps)(SwitchDiagnosticMode));
